import { Component, Inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChemicalExposureForm } from 'src/app/storage-user/forms/chemical-exposure.form';
import { createChemicalExposureForm } from 'src/app/storage-user/functions/create-chemical-exposure-form';
import { mapChemicalExposureRequest } from 'src/app/storage-user/functions/map-chemical-exposure-request';
import { ModuleName } from '../../enums/enums';
import { StockForm } from '../../forms/stock.form';
import { markControlsAsTouched } from '../../functions/mark-controls-as-touched';
import { IStock } from '../../models/stock.model';

export interface UseStockModalData {
  id: string;
  departmentId?: string;
  currentStock: number;
  module: ModuleName.STORAGE;
  isChemical?: boolean;
  substanceName?: string;
  manufacturerName?: string;
}

@Component({
  selector: 'app-use-stock-modal',
  templateUrl: './use-stock-modal.component.html',
  styleUrls: ['./use-stock-modal.component.scss'],
  standalone: false,
})
export class UseStockModalComponent {
  form: StockForm;
  chemicalExposureForm: ChemicalExposureForm | null = null;

  constructor(
    public dialogRef: MatDialogRef<UseStockModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: UseStockModalData
  ) {
    this.form = new StockForm(this.data.id, this.data.currentStock);
    this.form.amount.addValidators(Validators.max(this.data.currentStock));
    if (this.data.isChemical) {
      this.chemicalExposureForm = createChemicalExposureForm({
        name: this.data.substanceName,
        maker: this.data.manufacturerName,
      });
    }
  }

  get isFormValid(): boolean {
    if (this.chemicalExposureForm && !this.chemicalExposureForm.valid) {
      return false;
    }
    return this.form.valid;
  }

  save(): void {
    markControlsAsTouched(this.form);
    if (this.chemicalExposureForm) {
      markControlsAsTouched(this.chemicalExposureForm);
      this.chemicalExposureForm.updateValueAndValidity();
    }

    if (!this.isFormValid) {
      return;
    }

    const result: IStock = this.form.value;
    if (this.chemicalExposureForm) {
      result.chemicalExposure = mapChemicalExposureRequest(this.chemicalExposureForm.getRawValue());
    }

    this.dialogRef.close(result);
  }
}
